export default __webpack_public_path__ + "images/4b0b648e-accepted.svg";